/**
 * Test ids of the ArticleIndex settings panel. The single source is the shared test-kit registry
 * (EDITOR.articleIndex, mirrored byte-identical in .claude/ and .agents/) — never hardcode them.
 */
import { EDITOR } from '@test-kit/selectors/editor';

export const ARTICLE_INDEX_TEST_IDS = EDITOR.articleIndex;
